import type { DaemonHealth } from '../../api/types'

export type Rgb = readonly [number, number, number]

const DAEMON_COLORS: Record<string, Rgb> = {
  healthy: [0.133, 0.827, 0.933],
  degraded: [0.984, 0.749, 0.141],
  down: [0.937, 0.267, 0.267],
}

export interface DaemonStatusView {
  rgb: Rgb
  cssColor: string
  pulseSpeed: number
  label: string
}

export function daemonColor(status?: string): Rgb {
  return DAEMON_COLORS[status ?? 'down'] ?? DAEMON_COLORS.down
}

export function daemonPulseSpeed(status?: string): number {
  return status === 'down' ? 4 : status === 'degraded' ? 2 : 0.8
}

export function daemonStatusView(
  health: DaemonHealth | null,
  options: { includePool?: boolean } = {},
): DaemonStatusView {
  const rgb = daemonColor(health?.status)
  const pulseSpeed = daemonPulseSpeed(health?.status)
  const cssColor = health
    ? `rgb(${Math.round(rgb[0] * 255)},${Math.round(rgb[1] * 255)},${Math.round(rgb[2] * 255)})`
    : '#475569'
  if (!health) return { rgb, cssColor, pulseSpeed, label: 'DAEMON · OFFLINE' }
  const hours = Math.floor(health.uptime / 3600)
  const minutes = Math.floor((health.uptime % 3600) / 60)
  const pool =
    options.includePool !== false && health.poolSize != null
      ? ` · ${health.activeAgents ?? 0}/${health.poolSize} agents`
      : ''
  return {
    rgb,
    cssColor,
    pulseSpeed,
    label: `DAEMON · ${health.status.toUpperCase()} · up ${hours}h ${minutes}m${pool}`,
  }
}

const RUN_STATUS_COLORS: Record<string, string> = {
  completed: '#22d3ee',
  running: '#a78bfa',
  queued: '#94a3b8',
  pending: '#94a3b8',
  failed: '#f87171',
  cancelled: '#6b7280',
}

export function runStatusColor(status: string): string {
  return RUN_STATUS_COLORS[status] ?? '#94a3b8'
}
